import { PaymentMethodPickerItemType } from "types/components/PaymentMethodPicker";
import useGetData from "hooks/api/useGetData";
import { useTranslation } from "react-i18next";
import useGetPrice from "hooks/utils/useGetPrice";
import { useParams } from "react-router-dom";
import { COMPANY_FLOW_TYPE } from "constants/flowTypes";

const useGetPaymentMethodContent = ({
  productQuantityWatcher
}: {
  productQuantityWatcher?: number;
}): PaymentMethodPickerItemType[] => {
  const { data } = useGetData();
  const { type } = useParams();
  const { subtotalPrice } = useGetPrice({ productQuantityWatcher });

  const { i18n } = useTranslation();
  const paymentMethodItems = data?.paymentMethods?.map(({ paymentProviderId, name, min, max }) => {
    const isValidAmount = +`${subtotalPrice}` >= +`${min}` && +`${subtotalPrice}` <= +`${max}`;

    return {
      id: paymentProviderId,
      text: name?.find((name) => name.lang === i18n.language)?.text,
      disabled: type !== COMPANY_FLOW_TYPE && !isValidAmount
    };
  });

  return paymentMethodItems || [];
};

export default useGetPaymentMethodContent;
